module.exports = __webpack_public_path__ + "static/media/onda-violeta2.3a6f3f6d.png";